import React from "react";
import Overview from "./EducationOverview";
import EducationCSS from "../../../style/helperCSS/Education.module.css";

const Education = (props) => {
  if (props.overview_items) {
    return (
      <div>
        <div className={`${EducationCSS.education_div}`}>
          <div className={`row ${EducationCSS.education_content_div}`}>
            <div className={`col-3 col-md-2 ${EducationCSS.logo_div}`}>
              <img
                className={` ${EducationCSS.logo_container}`}
                src={props.institute_logo}
                alt="Institution Logo"
              ></img>
              <div className={`col-1 ${EducationCSS.vertical_line}`}></div>
            </div>
            <div className={`col-9 col-md-10 ${EducationCSS.institute_div}`}>
              <div className={`row`}>
                <div className={`col-12 col-md-9 ${EducationCSS.institute}`}>
                  <h4>
                    <a href={props.website} target="_blank">
                      {props.institute_name}
                    </a>
                  </h4>
                  <p className={`${EducationCSS.degree_tag}`}>{props.degree}</p>
                  <p>
                    {`${props.result} `}
                    <span
                      className={`${EducationCSS.grade_value}`}
                    >{`(${props.grading_type} ${props.earned_gpa}/${props.total_gpa})`}</span>
                  </p>
                  <p className={`${EducationCSS.degree_tag}`}>
                    {props.certificate_name}
                  </p>
                </div>
                <div
                  className={`col-12 col-md-3  ${EducationCSS.location_div}`}
                >
                  <p>{props.year}</p>
                  <p>{props.location}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Overview overviews={props.overview_items} />
      </div>
    );
  } else {
    return (
      <div className={`${EducationCSS.education_div}`}>
        <div className={`row ${EducationCSS.education_content_div}`}>
          <div className={`col-3 col-md-2 ${EducationCSS.logo_div}`}>
            <img
              className={` ${EducationCSS.logo_container}`}
              src={props.institute_logo}
              alt="Institution Logo"
            ></img>
            <div className={`col-1 ${EducationCSS.vertical_line}`}></div>
          </div>
          <div className={`col-9 col-md-10 ${EducationCSS.institute_div}`}>
            <div className={`row`}>
              <div className={`col-12 col-md-9 ${EducationCSS.institute}`}>
                <h4>
                  <a href={props.website} target="_blank">
                    {props.institute_name}
                  </a>
                </h4>
                {props.certificate_name ? (
                  <p className={`${EducationCSS.degree_tag}`}>
                    {props.certificate_name}
                  </p>
                ) : null}
                <p>{props.degree}</p>
                <p>
                  {`${props.result} `}
                  <span
                    className={`${EducationCSS.grade_value}`}
                  >{`(${props.grading_type} ${props.earned_gpa}/${props.total_gpa})`}</span>
                </p>
              </div>
              <div className={`col-12 col-md-3  ${EducationCSS.location_div}`}>
                <p>{props.year}</p>
                <p>{props.location}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default Education;
